export const AUTO_UPGRADE_AWARENESS_SOURCE = 'autoUpgradeAwareness';

// AUA button
export const PERSISTENT_UPGRADE_FLOWID = 'upgradeFlow';
export const PERSISTENT_UPGRADE_TOUCHPOINT_BUTTON = 'persistent-upgrade-button';
export const PERSISTENT_UPGRADE_ANALYTICS_SOURCE = 'persistentUpgrade';
export const AUTO_UPGRADE_AWARENESS_FREE_PILL_TOUCHPOINT = 'autoUpgradeAwarenessFreePill';
export const AUTO_UPGRADE_AWARENESS_STANDARD_PILL_TOUCHPOINT = 'editionAwarenessStandardPill';
export const AUTO_UPGRADE_AWARENESS_PILL_LOW_USER_COUNT = 'lowCount';
export const AUTO_UPGRADE_AWARENESS_PILL_HIGH_USER_COUNT = 'highCount';
